export default "__VITE_ASSET__l8MW2U_I__"